import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'evo-web-feed',
  name: 'Evo Web Feed',
  category: 'access-integrations',
  description: 'Send, update, or delete feed items in the Evo Web Feed',
  icon: 'Rss',
  color: 'blue',
  version: '1.0.0',
  comingSoon: false,
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
};

export default definition;
